/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: vKI2fFYew03y
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicButtonTab.module.css"; // plasmic-import: vKI2fFYew03y/css
import Workspace1024PxIcon from "./icons/PlasmicIcon__Workspace1024Px"; // plasmic-import: j0tmWm-TFnQe/icon

createPlasmicElementProxy;

export const PlasmicButtonTab__VariantProps = new Array("status", "color");

export const PlasmicButtonTab__ArgProps = new Array("iconTab", "onClick");

const $$ = {};

function PlasmicButtonTab__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"tabButton"}
      data-plasmic-override={overrides.tabButton}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.tabButton,
        {
          [sty.tabButtoncolor_light]: hasVariant($state, "color", "light"),
          [sty.tabButtonstatus__default]: hasVariant(
            $state,
            "status",
            "_default"
          ),
          [sty.tabButtonstatus_selected]: hasVariant(
            $state,
            "status",
            "selected"
          )
        }
      )}
    >
      <button
        data-plasmic-name={"tabButton2"}
        data-plasmic-override={overrides.tabButton2}
        className={classNames(
          projectcss.all,
          projectcss.button,
          projectcss.button__fRuRb,
          sty.tabButton2,
          { [sty.tabButton2color_light]: hasVariant($state, "color", "light") }
        )}
        onClick={async event => {
          const $steps = {};
          $steps["runOnClick"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onClick"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnClick"] != null &&
            typeof $steps["runOnClick"] === "object" &&
            typeof $steps["runOnClick"].then === "function"
          ) {
            $steps["runOnClick"] = await $steps["runOnClick"];
          }
        }}
        ref={ref => {
          $refs["tabButton2"] = ref;
        }}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <Workspace1024PxIcon
              className={classNames(projectcss.all, sty.svg__xxWYt)}
              role={"img"}
            />
          ),

          value: args.iconTab
        })}
      </button>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxstatus_selected]: hasVariant($state, "status", "selected")
        })}
      />
    </div>
  );
}

const PlasmicDescendants = {
  tabButton: ["tabButton", "tabButton2", "freeBox"],
  tabButton2: ["tabButton2"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonTab__ArgProps,
          internalVariantPropNames: PlasmicButtonTab__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "tabButton") {
    func.displayName = "PlasmicButtonTab";
  } else {
    func.displayName = `PlasmicButtonTab.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonTab = Object.assign(
  // Top-level PlasmicButtonTab renders the root element
  makeNodeComponent("tabButton"),
  {
    // Helper components rendering sub-elements
    tabButton2: makeNodeComponent("tabButton2"),
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicButtonTab
    internalVariantProps: PlasmicButtonTab__VariantProps,
    internalArgProps: PlasmicButtonTab__ArgProps
  }
);

export default PlasmicButtonTab;
/* prettier-ignore-end */
